import { Box, Checkbox } from '@atgfr8/atg-ui-tailwind';
import BottomSheet from '@mobileComponents/BottomSheet';
import {
  customerDetailsStore,
  setCustomerDetailsStore,
  updateCustomerDetailsState,
} from '@mobileStore/customer';
import { FeatureFlags } from '@constants/featureFlags';
import { isFeatureFlagEnabled } from '@mobileStore/featureFlags/store';
import { mobileUserStore } from '@mobileStore/user';
import { ICustomerDetails } from '@typeDefinitions/customerTypes';
import { mobileIsAdmin } from '@mobileUtils/roleUtils';
import { For } from 'solid-js';

type Props = {
  isOpen?: boolean;
  onClose?: () => void;
};

export type Group = {
  id: number;
  name: string | null;
  description: null | string;
  leader: null | string;
  groupLeaderId: number;
  leaderEmail: null | string;
  office: null | string;
  officeId: number | null;
  members: unknown | null;
  individual: boolean | null;
  status: string | null;
  userIds: number[] | null;
  dateCreated: string;
};

const AssignGroup = (props: Props) => {
  const handleAssignGroupChange = (values: Partial<ICustomerDetails>) => {
    updateCustomerDetailsState({
      ...customerDetailsStore.customer,
      ...values,
    });
  };
  const editable = () => {
    const roles = mobileUserStore.user.roles || [];
    return (
      roles.includes('Admin') ||
      roles.includes('Manager') ||
      roles.includes('Recruiter') ||
      roles.includes('Supervisor') ||
      isFeatureFlagEnabled(FeatureFlags.AssignMultiofficeGroupsForCustomer)()
    );
  };

  const handleGroupCheckboxChange = (group: Group, setFalse: boolean) => {
    if (!editable()) return;
    const groups = [...customerDetailsStore.customer.groups];
    const index = groups.findIndex((g) => g.id === group.id);

    if (setFalse && index === -1) {
      groups.push({ ...group });
    } else if (!setFalse && index >= 0) {
      groups.splice(index, 1);
    }

    if (
      groups.some(
        (g) =>
          g.name === 'The Office' &&
          g.officeId === customerDetailsStore.customer.accountManagerOfficeId,
      )
    ) {
      setCustomerDetailsStore('customer', 'isPublic', true);
    } else {
      setCustomerDetailsStore('customer', 'isPublic', false);
    }
    handleAssignGroupChange({ groups });
  };
  return (
    <BottomSheet
      title="Assign Groups"
      isOpen={props.isOpen}
      onClose={props.onClose}
    >
      <Box>
        <For
          each={customerDetailsStore.customer.groups.filter(
            (group) => mobileIsAdmin() || group.name !== 'The Office',
          )}
        >
          {(group) => (
            <Box class="mr-2">
              <Checkbox
                color="info"
                label={`${
                  Boolean(group.office)
                    ? `${group.name} (${group.office})`
                    : `${group.name}`
                }`}
                checked={true}
                size="xs"
                onChange={() => {
                  handleGroupCheckboxChange(group, false);
                }}
                dataTestId={`general-ownership-customer-group-checkboxInput-${group.id}`}
              />
            </Box>
          )}
        </For>
        <For each={customerDetailsStore.assignOfficeGroup}>
          {(group) => {
            const localGroups = () =>
              customerDetailsStore.customer.groups.map((x) => x.id);
            return (
              <Box
                class={`${
                  localGroups().includes(Number(group.value)) ? 'hidden' : ''
                }`}
              >
                <Checkbox
                  color="info"
                  label={group.label}
                  size="xs"
                  onChange={() => {
                    handleGroupCheckboxChange(group, true);
                  }}
                  dataTestId={`general-ownership-assign-group-checkboxInput-${group.value}`}
                />
              </Box>
            );
          }}
        </For>
      </Box>
    </BottomSheet>
  );
};

export default AssignGroup;
